import flatten from 'flat'
import { createIntl, createIntlCache } from 'react-intl'

import commonConfig from './common.config.json'
import { funds2CartSubject, cart2FundsSubject } from '../data/subjects/fundComparisonSubject'

const cache = createIntlCache()

let intl = null
let globalObserver = null

const isPROD = process.env.NODE_ENV === 'production'
const COUNTRY_CODE = process.env.REACT_APP_TW_COUNTRY_CODE
const prefixPath = `${window.location.pathname.split('/fundui')[0]}/fundui`

// const completeFullUrl = ({ countryCode, languageCode, location }) => {
//   const currentOrigin = window.location.origin
//   const currentFullUrl = queryString.parseUrl(currentUrl, { arrayFormat: 'comma' })
//   const { pathname } = location
//   const splitedPath = pathname.split('/')
//   const prePathArray = ['', ...(isPROD ? [prefixPath] : [countryCode]), ...(languageCode ? [languageCode] : [])]
//   const fullPathname = prePathArray.concat(splitedPath.filter((subPath) => !prePathArray.includes(subPath))).join('/')

//   currentFullUrl.url = `${currentOrigin}${fullPathname}`
//   const newFullUrl = queryString.stringifyUrl(currentFullUrl, { arrayFormat: 'comma' })

//   return newFullUrl
// }

const setGlobalParams = (params) => {
  if (globalObserver) {
    globalObserver = { ...globalObserver, ...params }
  } else {
    globalObserver = params
  }
}

const getCountryInfo = ({ pathname }) => {
  const splitedPath = pathname.split('/')
  const pathAarry = splitedPath.filter((item) => item !== '')
  const countryCode = isPROD ? COUNTRY_CODE : pathAarry[0]
  const languageCode = isPROD ? pathAarry[0] : pathAarry[1]

  let langCode = ''
  let cCode = ''

  if (commonConfig.countries[countryCode]) {
    cCode = countryCode
  } else {
    cCode = commonConfig.countries.default
  }

  const { countryName, defaultLanguage, languages } = commonConfig.countries[cCode]

  if (languages && languages.indexOf(languageCode) > -1) {
    langCode = languageCode
  } else {
    langCode = defaultLanguage || ''
  }

  return {
    countryCode: cCode,
    countryName,
    languageCode: langCode
  }
}

const getTerms = async (countryName, languageCode) => {
  const terms = await import(`../components/pages/${countryName}/terms${languageCode ? `_${languageCode}` : ''}.json`)
  return {
    originTerms: terms.default,
    flattenTerms: flatten(terms.default)
  }
}

const getBaseUrl = (countryCode, languageCode) => {
  if (isPROD) {
    return `${prefixPath}${languageCode ? `/${languageCode}` : ''}`
  }
  return `/${countryCode}${languageCode ? `/${languageCode}` : ''}`
}

const init = async (location) => {
  const defaultComparisonLimit = 5
  const { countryCode, countryName, languageCode, fullPath } = getCountryInfo(location)
  // const newFullUrl = completeFullUrl({ countryCode, languageCode, location })

  // if (window.location.href !== newFullUrl) {
  //   window.location.href = newFullUrl
  // }

  const currentHostName = window.location.hostname
  const favListName = `${currentHostName}_favItem`
  const fundComparisonCart = `${currentHostName}_fundComparison`

  const baseUrl = getBaseUrl(countryCode, languageCode)

  const sepcificCountryConfig = await import(`../components/pages/${countryName}/config.json`)
  const configLocale = sepcificCountryConfig.default.common.locale
  const locale = typeof configLocale === 'object' ? configLocale[languageCode] : configLocale

  const { originTerms, flattenTerms } = await getTerms(countryName, languageCode)

  intl = createIntl(
    {
      locale,
      messages: flattenTerms
    },
    cache
  )

  let funds2CartJob = null
  let cart2FundJob = null
  const hasFundComparison = sepcificCountryConfig.default?.fundComparison && sepcificCountryConfig.default.fundComparison.displayPages

  if (hasFundComparison) {
    funds2CartJob = funds2CartSubject()
    cart2FundJob = cart2FundsSubject()
  }

  setGlobalParams({
    baseUrl,
    terms: originTerms,
    countryConfig: sepcificCountryConfig.default,
    locale,
    favListName,
    fundComparisonCart,
    hasFundComparison,
    ...(hasFundComparison
      ? {
          funds2CartJob,
          cart2FundJob,
          comparisonLimit: sepcificCountryConfig.default?.fundComparison?.comparisonCount || defaultComparisonLimit
        }
      : {})
  })

  return {
    locale,
    fullPath,
    terms: flattenTerms,
    countryName,
    baseUrl,
    hasFundComparison,
    fundComparisonCart
  }
}

const getGlobalParams = () => globalObserver

const getCustomIntl = () => intl

export { init, getBaseUrl, getCustomIntl, getGlobalParams }
